<div class="fundraising-container">

    <ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
    </ngx-spinner>

      <div class="search-row align-center">
        <button style="box-shadow: 0 3px 15px 6px rgba(120, 99, 225, 0.22);" class="btn dark-btn" (click)="create()">
          Add Completed Game
        </button>
       <div class="input-with-icon align-row">
          <div class="input-icon align-center"><i class="flaticon-search"></i></div>
          <input
            type="text"
            placeholder="Search"
            (keyup)="search()"
            [(ngModel)]="searchText"
            class="searchtext"
        />
        </div>
        <div class="input-with-icon align-row">
            <select
                [(ngModel)]="selectedCampaign"
                (ngModelChange)="filterByCampaign()"
                class="searchtext">
                <option selected value='0'>
                    -- Filter games by Campaign --
                </option>
                <option *ngFor="let ppw of ppws; let i = index;" [value]="ppw.pledgePerWinId">
                    {{ ppw.event.name }}
                </option>
            </select>
          </div>
      </div>
      <mat-expansion-panel *ngFor="let group of gameGroups; let i = index;" class="fundraising-table" style="flex-direction: column; margin-bottom: 15px;">
        <mat-expansion-panel-header>
          <mat-panel-title style="color: #5e6383; font-family: Poppins; font-weight: 400; font-size: 1.5rem;">
            {{ group.group }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="panel-container">
          <div class="info-container" style="margin-top: 0;"></div>
          <div class="panel-table">
            <div class="data-row" style="box-shadow: 5px 5px 5px grey;" *ngFor="let game of group.children">
              <div class="data-row-content" style="height: 100%;">
                <div class="content-cell" style="justify-content: space-between;">
                  <div class="cell-row" style="justify-content: space-between;">
                    <h3 class="fundraiser-title">{{game.name}}</h3>
                    <div class="dropdown">
                      <div class="dots">
                        <img/>
                      </div>
                      <div class="dropdown-content">
                        <a (click)="view(game.pledgePerWinGameId)" href="#">View</a>
                        <a (click)="resendReportEmail(game.pledgePerWinGameId)" href="#">Resend Report Email</a>
                        <a *ngIf="game.status === 3" (click)="reverseCharges(game.pledgePerWinGameId)" class="delete-tab" href="#">Reverse Charges</a>
                      </div>
                    </div>
                  </div>
                  <div class="cell-row">      
                    <div 
                      *ngIf="game.status === 1"  
                      class="block-icon status org"
                      tooltip="The game was created successfully but charges have yet to be processed.">
                        <i 
                          class="flaticon-exclamation-2">
                        </i>
                        <span>Charges Pending</span>
                    </div>
                    <div 
                      *ngIf="game.status === 3"  
                      class="block-icon status grn"
                      tooltip="Charges have been processed successfully.">
                      <i 
                        class="flaticon-calendar-1">
                      </i>
                      <span>Charges Processed</span>
                    </div>
                    <div 
                      *ngIf="game.status === 4"  
                      class="block-icon status red"
                      tooltip="There was an error processing some or all of the charges. Please contact support@connectwithcue.com">
                      <i 
                        class="flaticon-exclamation-2">
                      </i>
                      <span>Processing Error</span>
                    </div>
                    <div 
                      *ngIf="game.status === 2"  
                      class="block-icon status red"
                      tooltip="Charges have been reversed and all pledges for this game have been refunded.">
                      <i 
                        class="flaticon-cancel">
                      </i>
                      <span>Charges Reversed</span>
                    </div>
                  </div>
                  <div class="cell-row">
                    <div>
                      <div class="info-container">
                        <span class="info-content">{{ game.totalRaised / 100 | currency }}</span>
                        <span class="info-title">Total Raised</span>
                      </div>
                      <div class="info-container">
                        <span class="info-content">{{game.pledgePerWin.team.name}}</span>
                        <span class="info-title">Team</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <div *ngIf="!gameGroups.length"> No Games to show</div>
</div>
